import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  List,
  ListItem,
  Alert,
  FormControlLabel,
  Switch,
} from '@mui/material';

interface SystemDialogProps {
  open: boolean;
  onClose: () => void;
  type: 'backup' | 'maintenance' | 'settings';
}

const SystemDialog: React.FC<SystemDialogProps> = ({ open, onClose, type }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        {type === 'backup' ? 'System Backup' :
         type === 'maintenance' ? 'Maintenance Mode' : 'System Settings'}
      </DialogTitle>
      <DialogContent>
        {type === 'backup' && (
          <Box>
            <Typography paragraph>
              Create a complete backup of the system including:
            </Typography>
            <List>
              <ListItem>• User data and profiles</ListItem>
              <ListItem>• Job postings and applications</ListItem>
              <ListItem>• Course content and enrollments</ListItem>
              <ListItem>• Test results and certificates</ListItem>
              <ListItem>• System configurations</ListItem>
            </List>
          </Box>
        )}
        {type === 'maintenance' && (
          <Box>
            <Alert severity="warning" sx={{ mb: 2 }}>
              Maintenance mode will make the system unavailable to users.
            </Alert>
            <Typography paragraph>
              Enable maintenance mode to perform system updates safely.
            </Typography>
            <FormControlLabel
              control={<Switch />}
              label="Enable maintenance mode"
            />
          </Box>
        )}
        {type === 'settings' && (
          <Box>
            <Typography paragraph>
              Configure system-wide settings and preferences.
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          Cancel
        </Button>
        <Button variant="contained" color="primary">
          {type === 'backup' ? 'Create Backup' :
           type === 'maintenance' ? 'Apply' : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SystemDialog;
